import { render, staticRenderFns } from "./ScalarValueInput.vue?vue&type=template&id=4823a768"
import script from "./ScalarValueInput.vue?vue&type=script&lang=js"
export * from "./ScalarValueInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports